<template>
  <v-container fluid>
    <v-toolbar
      flat
      class="toolbar--white get-height action-bar overflow--y"
      :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    >
      <Breadcrumb :routes="breadcrumbItems" />
      <v-spacer />

      <div class="text--nowrap">
        <FinancialDropdownActions
          v-if="hasRole('financial', 'ROLE_GET_ORDER_DOCUMENTS_URL') && showDownloadOptions"
          :files="showDownloadOptions"
        />

        <v-tooltip
          v-if="claims.billing['ROLE_GET_FINANCIAL_ACCOUNT_PAYMENT_METHOD']"
          :disabled="Boolean(company)"
          top
        >
          <v-btn
            :disabled="!Boolean(company)"
            slot="activator"
            round
            depressed
            color="accent"
            @click="openGlobalDrawer"
          >
            {{ $t('Common.paymentMethod') }}
          </v-btn>
          <span>{{$t('Common.selectCompany')}}</span>
        </v-tooltip>
      </div>
    </v-toolbar>

    <div class="page-content page-content--no-bg" :class="{'page__content--from-v4': noMainMenuFromV4}">
      <FinancialInvoicesHistory />
    </div>

    <GlobalDrawer
      :show="globalDrawer.visibility"
      :drawerType="globalDrawer.type"
      :data="globalDrawer.data"
      :actionType="globalDrawer.action"
      :filters="globalDrawer.filters"
      @close="closeGlobalDrawer"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'
import FinancialDropdownActions from './FinancialDropdownActions'
import FinancialInvoicesHistory from './FinancialInvoicesHistory'
import GlobalDrawer from 'components/globalDrawer'

export default {
  name: 'FinancialPage2',
  components: {
    Breadcrumb,
    FinancialDropdownActions,
    FinancialInvoicesHistory,
    GlobalDrawer
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen,
      company: state => state.company.selectedCompany,
      claims: state => state.userClaims.claims,
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    })
  },
  data () {
    return {
      namespace: 'Views.FinancialPage',
      breadcrumbItems: [
        { name: 'Financial', title: `${this.$t('Views.FinancialPage.title')}` }
      ],
      showDownloadOptions: null,
      globalDrawer: {
        visibility: false,
        type: '',
        data: {},
        filters: {},
        action: null
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleDownloadOptions (data) {
      this.showDownloadOptions = data
    },

    openGlobalDrawer ({ data = {}, filters = {}, action = 'preview' }) {
      this.globalDrawer = {
        visibility: true,
        type: 'paymentMethod',
        data,
        filters,
        action
      }
    },

    closeGlobalDrawer (reload = null) {
      this.globalDrawer = {
        visibility: false,
        type: '',
        data: {},
        filters: {},
        action: null
      }
    }
  }
}
</script>
